import { type QueryClient } from '@tanstack/react-query';

import { RQ_PREVIEW_EXPS_CACHE } from '../ReactQuery/cacheKeys';

import { OPTIMIZELY_EXPERIMENTS } from './config';
import {
  type CachedExperiments,
  type OpzlyExperimentsWithVariables,
  type OpzlyExperimentVariables,
} from './types';

type Params<T extends OpzlyExperimentsWithVariables> = {
  queryClient: QueryClient;
  experiment: T;
  fallback: OpzlyExperimentVariables<T>;
};

export function getExperimentVariables<
  T extends OpzlyExperimentsWithVariables,
>({
  queryClient,
  experiment,
  fallback,
}: Params<T>): OpzlyExperimentVariables<T> {
  const cachedExps = queryClient.getQueryData<CachedExperiments | undefined>([
    RQ_PREVIEW_EXPS_CACHE,
  ]);

  const parsedVariables = OPTIMIZELY_EXPERIMENTS[
    experiment
  ].variables.safeParse(cachedExps?.[experiment]?.variables);

  if (parsedVariables.success) {
    return parsedVariables.data as OpzlyExperimentVariables<T>;
  }
  return fallback;
}
